import { useCallback } from "react";
import { useChecklistApi } from "@/react/hooks/useChecklistApi";
import { type StepKey, stepKeys } from "@/react/types/Checklist";
import { useEmailBroadcastSurveyModal } from "../SurveyModal/EmailBroadcastSurveyModal";
import { usePaywallSurveyModal } from "../SurveyModal/PaywallSurveyModal";

export const useMarkCompleteAction = (stepKey: StepKey) => {
  const { isUpdatingChecklist, updateChecklist } = useChecklistApi();
  const paywallSurveyModal = usePaywallSurveyModal();
  const emailBroadcastSurveyModal = useEmailBroadcastSurveyModal();

  const markComplete = useCallback(async () => {
    if (stepKey === stepKeys.setup_payments) {
      await paywallSurveyModal.show();
    } else if (stepKey === stepKeys.send_launch_announcement) {
      await emailBroadcastSurveyModal.show();
    } else {
      updateChecklist({ [stepKey]: true });
    }
  }, [stepKey, paywallSurveyModal, emailBroadcastSurveyModal, updateChecklist]);

  return {
    markComplete,
    isLoading: isUpdatingChecklist,
  };
};
